import React from 'react';
import { withRouter } from 'react-router-dom';
import Curator from './Curator';
import { navContent } from '../constants/constants';
import unitHelper from '../helpers/unitHelper';

const CONFLUENCE_INDEX = 'https://gumgum.jira.com/wiki/spaces/GCDC/pages/4223008799';

class Content extends React.Component {

  redirect() {
    const pathname = this.props.location.pathname;

    if (document.location.href === 'https://spec-sheet-uk.gumgum.com/') {
      window.location.replace('https://specs.gumgum.com/#/uk');
      return;
    }

    if (pathname === '/curator') return;

    const unit = unitHelper.getUnit(navContent, pathname);
    window.location.replace((unit && unit.url) || CONFLUENCE_INDEX);
  }

  componentDidMount() {
    this.redirect();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.redirect();
    }
  }

  render() {
    if (this.props.location.pathname === '/curator') {
      return <Curator />;
    }
    return null;
  }
}

export default withRouter(Content);
